<template>
  <div class="table-responsive-lg">
    <table class="table table-striped blue items-with-sub-lines">
      <thead>
        <tr class="align-bottom">
          <th>
            <template v-if="model.isFromClaim">
              {{ getContentItem("claim") }}
            </template>
            <template v-else-if="model.isFromReturn">
              {{ getContentItem("return") }}
            </template>
            <template v-else>
              {{ getContentItem("source") }}
            </template>
          </th>
          <th class="text-right">
            {{ getContentItem("Line") }}
          </th>
          <th>{{ getContentItem("PartNumber") }}</th>
          <th>{{ getContentItem("description") }}</th>
          <template v-if="model.isMcfa">
            <th>{{ getContentItem("poNumber") }}</th>
            <th>{{ getContentItem("htcCode") }}</th>
          </template>
          <th class="text-right">
            {{ getContentItem("shipped") }}
          </th>
          <template v-if="canSeeAnyPrice">
            <th class="text-right">
              {{ getContentItem("price") }}
            </th>
            <th v-if="model.isMcfa" class="text-right">
              {{ getContentItem("coreCosts") }}
            </th>
            <th class="text-right">
              {{ getContentItem("ExtPrice") }}
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, index) in model.lineItems">
          <tr :key="index">
            <td v-if="item.rowSpan" :rowspan="item.rowSpan + GetRowSpanForComments()">
              <template v-if="model.relatedRoute">
                <router-link :to="model.relatedRoute">
                  {{ item.source }}
                </router-link>
              </template>
              <template v-else>
                {{ item.source }}
              </template>
            </td>
            <template v-if="item.type === 'Comment'">
              <td class="text-right muted">
                {{ item.line }}
              </td>
              <td class="muted">
                <em>Comment</em>
              </td>
              <td colspan="100%" class="muted">
                {{ item.description }}
              </td>
            </template>
            <template v-else>
              <td class="text-right">
                {{ item.line }}
              </td>
              <td>
                <part-details-link :oem-part-code="item.partNumber" />
              </td>
              <td>{{ item.description }}</td>

              <template v-if="model.isMcfa">
                <td>{{ item.poNumber }}</td>
                <td>{{ item.htcCode }}</td>
              </template>

              <td class="text-right">
                {{ item.shipped }}
              </td>
              <template v-if="canSeeAnyPrice">
                <td class="text-right">
                  <currency-text
                    :amount="item.price"
                    :currency-code="model.currencyCode"
                  />
                </td>
                <td v-if="model.isMcfa" class="text-right">
                  <currency-text
                    :amount="item.coreCost"
                    :currency-code="model.currencyCode"
                  />
                </td>
                <td class="text-right">
                  <currency-text
                    :amount="item.extPrice"
                    :currency-code="model.currencyCode"
                  />
                </td>
              </template>
            </template>
          </tr>
          <template v-for="comment in item.comments">
            <tr :key="comment" />
            <tr  
              :key="comment"
            >
              <td class="text-right">
                {{ item.line }}
              </td>
              <td>
                Comment
              </td>
              <td>
                {{ comment }}
              </td>
              <td colspan="3" />
            </tr>
          </template>
        </template>
      </tbody>
      <tfoot v-if="canSeeAnyPrice">
        <tr class="row-sub-total">
          <td colspan="100%">
            <label for="subtotal" class="inline-label">{{ getContentItem("subtotal") }}:</label>
            <currency-text
              id="subtotal"
              :amount="model.subTotal"
              :currency-code="model.currencyCode"
            />
          </td>
        </tr>
        <tr v-if="model.dealerClaimAmount" class="row-sub-fee row-sub-dealer-claim-amount">
          <td colspan="100%">
            <label
              for="dealerClaimAmount"
              class="inline-label"
            >{{ getContentItem("ClaimAmount") }}:</label>
            (<currency-text
              id="dealerClaimAmount"
              :amount="model.dealerClaimAmount"
              :currency-code="model.currencyCode"
            />)
          </td>
        </tr>
        <tr v-if="model.dealerServiceFee" class="row-sub-fee row-sub-dealer-service-fee">
          <td colspan="100%">
            <label
              for="dealerServiceFee"
              class="inline-label"
            >{{ getContentItem("DealerServiceFee") }}:</label>
            <currency-text
              id="dealerServiceFee"
              :amount="model.dealerServiceFee"
              :currency-code="model.currencyCode"
            />
          </td>
        </tr>
        <tr v-if="model.subTotalCores" class="row-sub-fee row-sub-cores-subtotal">
          <td colspan="100%">
            <label
              for="subTotalCores"
              class="inline-label"
            >{{ getContentItem("SubTotalCores") }}:</label>
            <currency-text
              id="subTotalCores"
              :amount="model.subTotalCores"
              :currency-code="model.currencyCode"
            />
          </td>
        </tr>
        <tr v-if="model.total" class="row-total">
          <td colspan="100%">
            <label for="total" class="inline-label">{{ getContentItem("total") }}:</label>
            <currency-text
              id="total"
              :amount="model.total"
              :currency-code="model.currencyCode"
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { CurrencyText, PartDetailsLink } from "@/components";

  export default {
    name: "ModelGrid",
    components: {
      CurrencyText,
      PartDetailsLink,
    },
    props: {
      model: Object,
    },
    computed: {
      ...mapGetters(["getContentItem", "canSeeAnyPrice"]),
    },
    methods: {
      GetRowSpanForComments(){
        var count = 0;
        for(var i = 0; i < this.model.lineItems.length; i++){
          count += this.model.lineItems[i].comments?.length;
        }
        return count * 2;
      }
    }
  };
</script>
